<template>
  <div class="login">
    <a-spin :spinning="spinning">
      <div class="body">
        <div class="img"></div>
        <div>
          <Register
            @goLogin="goLogin"
            @forget="forget"
            @backLogin="backLogin"
          />
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { decUserLoginApi } from "@/api/declare.js";
import getMD5 from "@/plugins/getMD5";
import { mapGetters, mapActions } from "vuex";
import { validatePassword } from "@/plugins/validate";
import Register from "@/components/register/index.vue";
import ForgetPassword from "@/components/forget-password/index.vue";
import CompleteInformation from "@/components/complete-information/index.vue";
export default {
  components: { Register, ForgetPassword, CompleteInformation },
  data() {
    return {
      userName: "",
      passWord: "",
      checked: true,
      spinning: false,
      num: 0 /* 0为登录首页，1为注册页面，2为忘记密码页面  3为补全信息页面*/,
    };
  },
  methods: {
    forgetClick() {
      this.num = 2;
    },
    backLogin(val) {
      this.num = val;
    },
    //切换登入页
    goLogin() {
      this.num = 0;
    },
    //注册
    registerClick() {
      this.num = 1;
    },
    //忘记密码
    forget() {
      this.num = 2;
    },
    //配置令牌
    ...mapActions(["setToken"]),
    login() {
      // this.num = 3;
      // return
      if (this.userName == "") {
        this.$message.warning("用户名不能为空！");
        return false;
      }
      if (this.passWord == "") {
        this.$message.warning("密码不能为空！");
        this.checked = false;
        return false;
      }
      // if (!validatePassword(this.passWord.trim())) {
      //   this.$message.warning(
      //     "您的账号不是强密码，请前往新华日报健康客户端进行修改。密码要求：强制大写字母+小写字母+数字+特殊字符，8位以上！"
      //   );
      //   return false;
      // }
      let mdpass = "";
      getMD5(this.passWord.trim(), function (md5) {
        mdpass = md5;
      });

      this.spinning = true;

      this.userLogin({
        userName: this.userName,
        // password: this.passWord,
        password: mdpass,
      });

      // this.$router.push({
      //     path: '/ugc/workbench'
      // }).catch(e => { })
    },
    onChange(e) {
      this.checked = e.target.checked;
      console.log(this.checked);
    },
    //账号密码登陆
    userLogin(val = {}) {
      // let res = await productUserLogin({...val})
      decUserLoginApi({ ...val })
        .then((res) => {
          if (res && res.status) {
            if (this.checked) {
              let mdpass = "";
              getMD5(this.passWord.trim(), function (md5) {
                mdpass = md5;
              });
              localStorage.setItem(
                "loginInfo",
                JSON.stringify({ user: this.userName.trim(), psw: mdpass })
              );
            } else {
              localStorage.removeItem("loginInfo");
            }
            setTimeout(() => {
              this.setToken(res.data.userToken);
              this.spinning = false;
              sessionStorage.setItem(
                "userModel",
                JSON.stringify(res.data.productUserInfo)
              );
              localStorage.setItem(
                "userModel",
                JSON.stringify(res.data.productUserInfo)
              );
              this.$router.push("/skl/declarationCenter/projectDeclaration");
            }, 1000);
          } else {
            this.spinning = false;
            this.$message.error(res.message || "服务器发生错误");
          }
        })
        .catch(() => {
          this.spinning = false;
          this.$message.error("登录失败!");
        });
    },
  },
  created() {
    // if (sessionStorage.getItem("modifyInformation")) {
    //   this.num = 1;
    // }
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
